import { Dropdown } from "primereact/dropdown";
import "./style.css";
import {
  FilterTemplate,
  getPrimeOptionsFormatArr,
  ItemTemplate,
  ValueTemplate,
} from "../lib";

export const FieldsForMappingDropdown = ({
  optionsObjState,
  onShow,
  primeDropdownPropsObj,
  filterObjState,
}) => {
  const [optionsObjStateValue, setOptionsObjStateValue] = optionsObjState;

  return (
    <Dropdown
      {...primeDropdownPropsObj}
      options={getPrimeOptionsFormatArr(optionsObjStateValue)}
      onChange={(e) => {
        const actualValue = e.value;
        const actualValueOptionObj =
          optionsObjStateValue.allOptionsGroup.items.find(
            (optionObj) => optionObj.nameId === actualValue
          );
        setOptionsObjStateValue((prevValue) => ({
          ...prevValue,
          selectedOptionGroup: {
            label: "Wybrano",
            items: [actualValueOptionObj],
          },
        }));
        primeDropdownPropsObj.onChange(e);
      }}
      onShow={onShow}
      placeholder="Wybierz pole do synchronizacji"
      panelClassName="EmployeeDropdown_panel"
      optionValue="nameId"
      optionLabel="label"
      optionGroupLabel="label"
      filter
      filterTemplate={<FilterTemplate filterObjState={filterObjState} />}
      itemTemplate={(option) => <ItemTemplate optionObj={option} />}
      valueTemplate={(option, props) => (
        <ValueTemplate optionObj={option} propsObj={props} />
      )}
    />
  );
};
